import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserCountryCharges {
  constructor($scope, UserService) {
    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '600px'
    };

    $scope.$watch('continent', function() {
      $scope.selected_countries = [];
      if ($scope.continent && $scope.continent !== '') {
        var group = $('select#countries').find('optgroup[label="' + $scope.continent + '"]');
        group.find('option').each(function() {
          $scope.selected_countries.push($(this).attr('value'));
        });
      }
    });

    $scope.load_charges = function() {
      $scope.loading = true;
      UserService.get_country_charges(window.user_id).then(function(data) {
        $scope.charges = data.charges;
        $scope.loading = false;
      });
    };

    $scope.save_charge = function() {
      $scope.saving_charge = true;
      UserService.save_country_charges([$scope.charge]).then(function(data) {
        if (data.success) {
          $scope.saving_charge = false;
          $.fancybox.close();
          $scope.load_charges();
        }
      });
    };

    $scope.save_charges = function() {
      $scope.saving_countries_charge = true;
      var charges = [];
      _.each($scope.selected_countries, function(country) {
        var c = angular.copy(window.harge);
        c.country_id = country;
        c.charge = $scope.country_charge;
        charges.push(c);
      });
      if (charges.length > 0) {
        UserService.save_country_charges(charges).then(function(data) {
          if (data.success) {
            $scope.saving_charges = false;
            $scope.load_charges();
          }
        });
      }
    };

    $scope.edit_charge = function(charge) {
      $scope.charge = charge;
      window.openFancyboxDialog('div#charge_dialog');
    };

    $scope.delete_charge = function(charge_id) {
      if (confirm('Are you sure you want to delete this charge?')) {
        UserService.delete_country_charge(charge_id).then(function(data) {
          if (data.success)
            $scope.load_charges();
        });
      }
    };

    $scope.mass_delete_charges = function() {
      var charges = _.where($scope.charges, {
        checked: true
      });
      if (charges.length === 0) {
        alert('Please select at least one charge!');
      } else {
        $scope.processing = true;
        UserService.delete_country_charges(_.pluck(charges, 'id')).success(function(data) {
          if (data.success) {
            $scope.load_charges();
            $scope.processing = false;
          }
        });
      }
    };

    $scope.mass_edit_charges = function() {
      var charges = _.where($scope.charges, {
        checked: true
      });
      if (charges.length === 0)
        alert('Please select at least one charge!');
      else
        window.openFancyboxDialog('div#mass_charge_dialog');
    };

    $scope.mass_save_charges = function() {
      var charges = _.where($scope.charges, {
        checked: true
      });
      _.each(charges, function(charge) {
        if ($scope.mass_charge)
          charge.charge = $scope.mass_charge;
        if ($scope.mass_admin_expire_date)
          charge.admin_expire_date = $scope.mass_admin_expire_date;
      });
      $scope.saving_charges = true;
      UserService.save_country_charges(charges).then(function(data) {
        if (data.success) {
          $scope.load_charges();
          $scope.saving_charges = false;
          $.fancybox.close();
        }
      });
    };

    $scope.mass_renew_charges = function() {
      var charges = _.where($scope.charges, {
        checked: true
      });
      if (charges.length === 0) {
        alert('Please select at least one charge!');
      } else {
        $scope.processing = true;
        UserService.save_country_charges(charges).then(function(data) {
          if (data.success) {
            $scope.load_charges();
            $scope.processing = false;
          }
        });
      }
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.set_charges_checked = function() {
      _.each($scope.charges, function(charge) {
        charge.checked = $scope.checked_all_charges;
      });
    };

    $scope.init = function() {
      $scope.load_charges();
      $scope.countries = window.countries;
    };

    $scope.init();

  }
}

UserCountryCharges.$inject = ['$scope', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-country-charges.ctrl.js